import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const useGetEmployees = (params?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['get-employees'] as const,
    queryFn: async () => {
      const { error, data } = await supabaseApi.from('employees').select('*')

      if (error) throw error
      return data
    },
    enabled: params?.enabled,
  })
}
